import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { optCampaignNotPublishedFailure, optCampaignNotPublishedSuccess } from '../../actions/InfluencerCampaignActions/optCampaignNotPublishedActions';

function* optCampaignNotPublished({ payload, callback }) {
    try {
        const query = `?platform=${payload.platform}`;
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.optCampaignNotPublished + query,
            isAuth: true,
        });
        console.log('====================================');
        console.log("OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS status :", response.data.status);
        console.log("OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS data :", response.data.response);
        console.log("OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            optCampaignNotPublishedSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE status :", error?.response?.status);
        console.log("OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE data:", error?.response?.data);
        console.log("OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE error :", error);
        console.log('====================================');
        yield put(optCampaignNotPublishedFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* optCampaignNotPublishedSaga() {
    yield takeLatest(actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_REQUEST, optCampaignNotPublished);
}

export default optCampaignNotPublishedSaga;
